import type {
  DeletedOption,
  GenericOption,
} from 'pages/AutomationEngine/types';
import { CONFLICT_RESOLUTIONS, FILTER_TYPES } from './constants';
import type { TFunction } from 'react-i18next';
import type {
  ConflictResolution,
  SearchRecordsDetails,
  StepErrors,
} from './types';

export const getResolutionOptions = (t: TFunction) => {
  const options: GenericOption<ConflictResolution>[] = [
    {
      value: CONFLICT_RESOLUTIONS.add_only,
      label: t('Add Items to Array'),
    },
    {
      value: CONFLICT_RESOLUTIONS.overwrite,
      label: t('Overwrite Array (Clear Array if No Results)'),
    },
    {
      value: CONFLICT_RESOLUTIONS.overwrite_except_null,
      label: t('Overwrite Array (But Skip if No Results)'),
    },
    {
      value: CONFLICT_RESOLUTIONS.update_if_blank,
      label: t('Only Update Array if Blank'),
    },
    {
      value: CONFLICT_RESOLUTIONS.remove_only,
      label: t('Remove Items from Array'),
    },
  ];

  return options;
};

export const getValueWithDeleted = (
  option: DeletedOption | null,
  t: TFunction
) => {
  if (!option) return null;
  return {
    ...option,
    label: option.deleted ? `${option.label} ${t('[Deleted]')}` : option.label,
  };
};

export const prepareErrors = (
  values: SearchRecordsDetails,
  stepError: StepErrors,
  t: any
) => {
  const {
    custom_object,
    destination_variable,
    destination_variable_resolution,
    filter_type,
    filter_groups,
    filter_config,
  } = stepError || {};

  return {
    custom_object:
      custom_object ||
      (values.customObject?.deleted
        ? [
            t("Custom Object '{{value}}' is deleted", {
              value: values.customObject.label,
            }),
          ]
        : undefined),
    destination_variable:
      destination_variable ||
      (values.destinationVariable?.deleted
        ? [
            t("Variable '{{value}}' is deleted", {
              value: values.destinationVariable.label,
            }),
          ]
        : undefined),
    destination_variable_resolution,
    filter_type,
    filter_groups:
      filter_groups ||
      values.filterGroups?.some(({ deleted, invalid }) => deleted || invalid)
        ? [t('At least one selected group is invalid or deleted')]
        : undefined,
    filter_config:
      filter_config || values.filterConfig?.invalid
        ? [t('Please fix errors in your filter configuration.')]
        : undefined,
  };
};

export const getIsGroupFilter = (
  filterType: SearchRecordsDetails['filterType']
) => {
  return (
    filterType === FILTER_TYPES.in_group ||
    filterType === FILTER_TYPES.not_in_group
  );
};
